module.exports = __webpack_public_path__ + "static/Image1TEAM-0d384c1d2d0f52a353a0c7be79a4f303.png";